module.exports = __webpack_public_path__ + "img/search-group.fc79a81d.png";